import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type EmployeeModel from 'modules/employees/store/models/Employee'
import AssigneesSelector from 'modules/shift_management/components/ShiftManagement/AssigneesSelector'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useSelectionState } from 'modules/shift_management/hooks/useSelection'
import type CommonSelectorsForm from 'modules/shift_management/lib/forms/CommonSelectorsForm'

import SelectedCellsInfo from './SelectedCellsInfo'

interface Props {
  form: CommonSelectorsForm
  selectableEmployees: EmployeeModel[]
  selectedEmployees: number[]
  setSelectedEmployees: React.Dispatch<React.SetStateAction<number[]>>
  canReassignShifts?: boolean
  edit?: boolean
  fromLeave?: boolean
  canAdjustSelectedDates?: boolean
  contractVersions: ContractVersions
}

const EmployeesSection = ({
  form,
  selectableEmployees,
  selectedEmployees,
  setSelectedEmployees,
  canReassignShifts = false,
  edit = false,
  fromLeave = false,
  contractVersions,
}: Props) => {
  const [{ view }] = useSchedule()
  const { isEnabled: hasSelection } = useSelectionState()

  const showSelector = view.isByEmployees || (view.isByAreas && edit) ? canReassignShifts : true

  const showDates = !fromLeave || (!!fromLeave && !view.isWeekly)

  return (
    <Box gap="s16">
      {hasSelection && !canReassignShifts && (
        <SelectedCellsInfo
          employeeIds={selectedEmployees}
          showDates={showDates}
          contractVersions={contractVersions}
        />
      )}
      {!fromLeave && (!hasSelection || showSelector) && (
        <AssigneesSelector
          form={form}
          selectableEmployees={selectableEmployees}
          selectedEmployees={selectedEmployees}
          setSelectedEmployees={setSelectedEmployees}
          contractVersions={contractVersions}
        />
      )}
    </Box>
  )
}

export default observer(EmployeesSection)
